import React from "react";
import { useAuth } from "../../../../firebase/AuthContext";
import sidebarImage from "../docsAssets/sidebarMenu_screenshot.png";
import sidebarVideo from "../docsAssets/sidebar_video.mp4";

export default function DashboardTutorial({ isEN }) {
  const { currentUser } = useAuth();
  const [isPreviewOpen, setIsPreviewOpen] = React.useState(false);
  const [previewSrc, setPreviewSrc] = React.useState("");

  const openPreview = (src) => {
    setPreviewSrc(src);
    setIsPreviewOpen(true);
  };

  const closePreview = () => {
    setIsPreviewOpen(false);
    setPreviewSrc(null);
  };

  if (!currentUser) {
    return (
      <div className="flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
            {/* Header with icon */}
            <div className="bg-gradient-to-r from-orange-500 to-red-500 px-6 py-8 text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-white mb-2">
                {isEN ? "Access Required" : "需要存取權限"}
              </h2>
              <p className="text-orange-100 text-sm">
                {isEN ? "Troubleshooting Guide" : "故障排除指南"}
              </p>
            </div>

            {/* Content */}
            <div className="px-6 py-8">
              <div className="text-center mb-6">
                <h3 className="text-gray-800 dark:text-white font-semibold text-lg mb-3">
                  {isEN ? "Please log in to continue" : "請登錄以繼續"}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
                  {isEN
                    ? "You need to be authenticated to access the troubleshooting guide and technical support resources."
                    : "您需要進行身份驗證才能訪問故障排除指南和技術支持資源。"}
                </p>
              </div>

              {/* Features preview */}
              <div className="space-y-3 mb-8">
                <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                  <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                  {isEN ? "Common issues & solutions" : "常見問題和解決方案"}
                </div>
                <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                  {isEN ? "Step-by-step guides" : "分步指南"}
                </div>
                <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                  <div className="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                  {isEN ? "Direct support contact" : "直接支持聯繫"}
                </div>
              </div>

              {/* Login prompt */}
              <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
                <p className="text-center text-gray-700 dark:text-gray-300 text-sm">
                  {isEN
                    ? "Return to the main page to sign in with your account"
                    : "返回主頁面使用您的帳戶登錄"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center mb-8">
        {/* <div className="w-10 h-10 bg-orange-500 rounded-xl flex items-center justify-center mr-4 shadow-lg">
                    <svg
                        className="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                        />
                    </svg>
                </div> */}
        <div>
          <h2 className="text-3xl font-bold text-gray-800 dark:text-white">
            {isEN ? "Dashboard Tutorial" : "儀表板教學"}
          </h2>
          <p className="text-gray-500 dark:text-gray-400 mt-1">
            {isEN ? "Master your dashboard navigation" : "掌握您的儀表板導航"}
          </p>
        </div>
      </div>
      <div className="space-y-6">
        <div className="bg-slate-200 dark:bg-gray-900/40 rounded-xl p-8 border border-gray-300 dark:border-gray-700 shadow-lg">
          <div className="flex items-center mb-6">
            <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 dark:text-white">
              {isEN ? "Dashboard Overview" : "儀表板概覽"}
            </h3>
          </div>
          <p className="text-gray-700 dark:text-gray-300 mb-8 text-lg leading-relaxed">
            {isEN
              ? "Learn how to navigate and use T-Global PIMS dashboard interface effectively."
              : "了解如何有效地導航和使用 T-Global PIMS 儀表板介面。"}
          </p>

          <div className="grid md:grid-cols-2 gap-6 mb-8">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
                                    <svg
                                        className="w-5 h-5 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white font-semibold text-xl">
                  {isEN ? "Dashboard Screenshot" : "儀表板截圖"}
                </h4>
              </div>
              <div className="bg-gray-900 rounded-lg overflow-hidden shadow-inner border border-gray-700 cursor-pointer transform transition-transform hover:scale-105">
                <img
                  src={sidebarImage}
                  alt={isEN ? "Dashboard Screenshot" : "儀表板截圖"}
                  className="w-full h-auto object-cover"
                  role="button"
                  onClick={() => openPreview(sidebarImage)}
                />
              </div>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
                                    <svg
                                        className="w-5 h-5 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white font-semibold text-xl">
                  {isEN ? "Key Features" : "主要功能"}
                </h4>
              </div>
              <ul className="text-gray-700 dark:text-gray-300 space-y-3">
                <li className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span>
                    {isEN ? "Real-time chat interface" : "即時聊天介面"}
                  </span>
                </li>
                <li className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span>{isEN ? "Message history" : "消息歷史"}</span>
                </li>
                <li className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span>{isEN ? "Session management" : "會話管理"}</span>
                </li>
                <li className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span>{isEN ? "Feedback system" : "反饋系統"}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm mb-8">
            <div className="flex items-center mb-6">
              {/* <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
                                <svg
                                    className="w-5 h-5 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M13 10V3L4 14h7v7l9-11h-7z"
                                    />
                                </svg>
                            </div> */}
              <h4 className="text-gray-800 dark:text-white font-semibold text-xl">
                {isEN ? "Quick Start Guide" : "快速入門指南"}
              </h4>
            </div>
            <div className="space-y-4">
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center text-white text-sm font-bold shadow-md">
                  1
                </div>
                <p className="text-gray-700 dark:text-gray-300 pt-1">
                  {isEN
                    ? "Access the dashboard from the main menu"
                    : "從主選單存取儀表板"}
                </p>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center text-white text-sm font-bold shadow-md">
                  2
                </div>
                <p className="text-gray-700 dark:text-gray-300 pt-1">
                  {isEN
                    ? "Start a new conversation by typing in the chat box"
                    : "在聊天框中輸入內容開始新對話"}
                </p>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center text-white text-sm font-bold shadow-md">
                  3
                </div>
                <p className="text-gray-700 dark:text-gray-300 pt-1">
                  {isEN
                    ? "Use the sidebar to access chat history and settings"
                    : "使用側邊欄訪問聊天歷史和設置"}
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
            <div className="flex items-center mb-4">
              {/* <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
                                <svg
                                    className="w-5 h-5 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293H15"
                                    />
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>
                            </div> */}
              <h4 className="text-gray-800 dark:text-white font-semibold text-xl">
                {isEN
                  ? "Navigate through all the panel by directly clicking the sidebar Menu options"
                  : "透過直接點擊側邊欄選單選項來瀏覽所有面板"}
              </h4>
            </div>
            <div className="bg-gray-900 rounded-lg overflow-hidden shadow-inner border border-gray-700">
              <video className="w-full h-full object-cover" controls>
                <source src={sidebarVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            <div className="flex items-center mt-3 text-gray-600 dark:text-gray-400 text-sm">
              <svg
                className="w-4 h-4 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              {isEN ? "Duration: 0:27" : "時長: 0:27"}
            </div>
          </div>
        </div>
      </div>
      {isPreviewOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
          onClick={closePreview}
        >
          <div
            className="relative max-w-4xl max-h-[90vh] p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-2 right-2 text-white bg-black/40 rounded-full w-8 h-8 flex items-center justify-center"
              onClick={closePreview}
              aria-label="Close preview"
            >
              ×
            </button>
            <img
              src={previewSrc}
              alt="Preview"
              className="w-auto max-w-full max-h-[80vh] rounded-md object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
}
